import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Container,
  Divider,
  Grid,
  makeStyles,
  Typography
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React from 'react';
import BaseButton from '../Buttons/BaseButton';
import { history } from '../../Routes/history';
import SvgIcEye from '../CustomIcons/EyeIcon';
import { moneyWithDots } from '../../Utils/Format/MoneyFormat';
import clsx from 'clsx';
import { ROUTE_NAMES } from '../../Routes/Routes';
import {
  ConstructorRequestType,
  PARSED_CONSTRUCTOR_CLIENT_IDENTIFICATION_TYPE
} from '../../Enums/constructors';

const redirectToPhaseDetails = contractId => {
  history.push(`${ROUTE_NAMES.constructorPhase}/${contractId}`);
};

const ProjectAccordion = ({ project, phases }) => {
  const classes = useStyles();
  const redirectToQuotationRequest = () => {
    history.push(
      `${ROUTE_NAMES.constructorRequest}/${ConstructorRequestType.Quotation}`,
      {
        constructorInfo: {
          projectName: project.name,
          projectConsecutive: project.consecutive,
          businessName: project.client.name,
          businessIdentification: project.client.identification,
          businessIdentificationType:
            PARSED_CONSTRUCTOR_CLIENT_IDENTIFICATION_TYPE[
              project.client.identificationType
            ]
        }
      }
    );
  };

  return (
    <Accordion variant="outlined">
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
        >
          <Grid item xs={12} md={3}>
            <Typography className={classes.subtitle}>Proyecto</Typography>
            <Typography className={classes.title}>{project.name}</Typography>
          </Grid>
          <Grid item>
            <Typography>
              Contratos legalizados: {project.totalActivatedUnits}/
              {project.totalUnits}
            </Typography>
          </Grid>
          <Grid item>
            <Typography>Total: {moneyWithDots(project.totalValue)}</Typography>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Grid container justifyContent="center">
              <Grid item>
                <BaseButton variant="text" onClick={redirectToQuotationRequest}>
                  Solicitar cotización
                </BaseButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <Divider />
          </Grid>
          <Grid item>
            <Container>
              <Grid container spacing={2}>
                {phases.map(phase => (
                  <Grid item xs={12} key={phase.contractId}>
                    <Grid
                      container
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Grid item xs={12} md={2}>
                        <Typography className={classes.subtitle}>
                          Etapa - Contrato
                        </Typography>
                        <Typography className={classes.title}>
                          {phase.name} - {phase.contractId}
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography>
                          Contratos legalizados: {phase.activeContracts}/
                          {phase.units}
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography>
                          Total: {moneyWithDots(phase.totalValue)}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm="auto">
                        <Grid container justifyContent="center">
                          <Grid item>
                            <BaseButton
                              variant="text"
                              onClick={() =>
                                redirectToPhaseDetails(phase.contractId)
                              }
                              startIcon={
                                <SvgIcEye
                                  width={24}
                                  height={24}
                                  className={clsx({
                                    [classes.disabledIcon]: phase.disabled
                                  })}
                                />
                              }
                              disabled={phase.disabled}
                            >
                              Ver detalle
                            </BaseButton>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            </Container>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

const useStyles = makeStyles(theme => ({
  title: {
    fontSize: '1em'
  },
  subtitle: {
    fontSize: '0.8em',
    color: theme.palette.text.greyDark
  },
  phasesDivider: {
    minWidth: '100%',
    marginBottom: theme.spacing(2)
  },
  actionIcon: {
    color: theme.palette.primary.main,
    fill: theme.palette.primary.main
  },
  disabledIcon: {
    color: theme.palette.primary.disabled,
    fill: theme.palette.primary.disabled
  }
}));
export default ProjectAccordion;
